import Axios from 'axios';
import config from '../../config';
import store from '../../store'
import router from '../../router'
import { saveRedirect } from '../../helpers'
const client = Axios;

const loginRoutes = [
  '/api/v1/auth/google',
  '/api/v1/auth/verify',
];

client.defaults.baseURL = config.getParameter('api_url');

client.interceptors.request.use(
  (axiosConfig) => {
    if (!loginRoutes.includes(axiosConfig.url) && !axiosConfig.silent) {
      store.commit('addLoadingRequest', null, { root: true })
    }

    const token = localStorage.getItem('token');
    if (token) {
      axiosConfig.headers.Authorization = `Bearer ${token}`;
    }
    return axiosConfig;
  },
  error => Promise.reject(error),
);

client.interceptors.response.use(
  (response)  => {
    if (!loginRoutes.includes(response.config.url) && !response.config.silent) {
      store.commit('removeLoadingRequest', null, { root: true })
    }

    return response
  },
  (error) => {
    // Only send errors not related with the authorization
    if (!loginRoutes.includes(error.config.url) && !error.config.silent) {
      store.commit('removeLoadingRequest', null, { root: true })
    }

    handleSessionExpiry(error);

    return Promise.reject(error);
  }
);

// Route navigation only validates the token on path changes, so an expiry
// during same-page interactions (pagination, filters) surfaces here as a data
// call 401 — bounce to login like the router validator does
function handleSessionExpiry(error) {
  const response = error.response;
  if (!response || response.status !== 401 || loginRoutes.includes(error.config.url)) {
    return;
  }

  if (localStorage.getItem('token') == null) {
    return;
  }

  localStorage.removeItem('token');
  store.commit('authentication/setError', 'Session expired. Please login again');

  const current = router.currentRoute;
  if (current.matched.some(record => !record.meta.public)) {
    saveRedirect(current.fullPath);
    router.push('/').catch(() => {});
  }
}

export default client;
